// The official rules document of GET /api/rewards/dream/rules/{school_id}/
// (`document`: the sweepstakes rules filled in by the server), checked before it
// is printed. The app, the embed and the fan web page read it the same way
// (officialRules.js in each).

function textOf(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function lines(value) {
  return (Array.isArray(value) ? value : []).map(textOf).filter(Boolean);
}

/**
 * { title, notice, intro, sections: [{ heading, paragraphs, list }] }, or null
 * when the answer has no document to print (no period, or an older server).
 */
export function readRulesDocument(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const title = textOf(raw.title);
  const sections = (Array.isArray(raw.sections) ? raw.sections : [])
    .filter((section) => section && typeof section === 'object')
    .map((section) => ({
      heading: textOf(section.heading),
      paragraphs: lines(section.paragraphs),
      list: lines(section.list),
    }))
    .filter((section) => section.heading);
  if (!title || !sections.length) return null;
  return { title, notice: textOf(raw.notice), intro: lines(raw.intro), sections };
}

/** The rules page link of one prize draw or bonus drop: the summary's rules_url plus its prizeId. */
export function prizeRulesUrl(rulesUrl, prizeId) {
  if (!rulesUrl || !prizeId) return rulesUrl || '';
  return rulesUrl + (rulesUrl.includes('?') ? '&' : '?') + 'prizeId=' + encodeURIComponent(String(prizeId));
}

/** Printed above the school's rules when a prize link answered 404 and the school's rules stand in for it. */
export const REPLACED_RULES_NOTICE =
  'The rules for this prize are no longer available. These are the school’s current official rules.';

/**
 * GET /api/rewards/dream/rules/{school_id}/ for a link: of its prize, or of the
 * school when the prize link answers 404 (the prize was removed or is no longer
 * shown to fans). `getRules(schoolId, prizeId)` is the client's request.
 * Returns { rules, replaced }: `replaced` is true when the school's rules stand in for the prize's.
 */
export async function loadRules(getRules, schoolId, prizeId) {
  try {
    return { rules: await getRules(schoolId, prizeId), replaced: false };
  } catch (error) {
    const status = error && (error.response ? error.response.status : error.status);
    if (!prizeId || status !== 404) throw error;
    return { rules: await getRules(schoolId, ''), replaced: true };
  }
}
